// Variants
import { VARIANTS } from '@openbank/ziniaweb-ui-components';

const SELECT_IBAN_FOOTER_ACTION_PROPS = {
    'data-testid': 'select-iban-footer-action',
    'variant': VARIANTS.FooterVariantsType.ACTION_BUTTONS,
  },
  SELECT_IBAN_FOOTER_ACTION_LINK_PROPS = {
    'data-testid': 'select-iban-footer-action-link',
    'type': 'SECONDARY',
    'size': 'LARGE',
    'disabled': false,
  },
  SELECT_IBAN_FOOTER_ACTION_BUTTON_PROPS = {
    'data-testid': 'select-iban-footer-action-button',
    'type': 'PRIMARY',
    'size': 'LARGE',
  },
  SELECT_IBAN_INPUT_PROPS = {
    errorIcon: 'icon_symbols_alert',
    id: 'select-iban-input',
    name: 'inputName',
    noResultsText: {
      content: 'No se han encontrado resultados',
    },
    variant: 'REGULAR',
    optionList: {
      options: [
        {
          label: 'ES10 2095 2579 043257425859',
          value: 'option 1',
        },
        {
          label: 'ES30 2038 3185 70 6519479178',
          value: 'option 2',
        },
        {
          label: 'ES20 2208 3321 23 6519479891',
          value: 'option 3',
        },
      ],
    },
  };

export {
  SELECT_IBAN_FOOTER_ACTION_PROPS,
  SELECT_IBAN_FOOTER_ACTION_LINK_PROPS,
  SELECT_IBAN_FOOTER_ACTION_BUTTON_PROPS,
  SELECT_IBAN_INPUT_PROPS,
};
